var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"caption grey--text font-weight-bold mb-3 nowrap"},[_vm._v(" "+_vm._s(_vm.label)+" "),_vm._t("label")],2),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }